import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';

export default [
  {
    path: '/IFPageEightyFourPreLogin',
    name: 'IFPageEightyFourPreLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageEightyFour/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageEightyFourLogin' ||
        from.path === '/IFPageEightyFourLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageEightyFourLogin',
    name: 'pageEightyFourLogin',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageEightyFour/login.vue'),
  },
  {
    path: '/IFPageEightyFourLeaveInfo',
    name: 'pageEightyFourLeaveInfo',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageEightyFour/leaveInfo.vue'),
  },
  {
    path: '/IFPageEightyFourResult',
    name: 'pageEightyFourResult',
    meta: {
      title: '星贷',
    },
    component: () => import('@/pages/pageListAll/pageEightyFour/result.vue'),
  },
  {
    path: '/IFPageEightyFourLoading',
    name: 'pageEightyFourLoading',
    component: () => import('@/pages/pageListAll/pageEightyFour/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageEightyFourLoginSecond',
    name: 'pageEightyFourLoginSecond',
    component: () => import('@/pages/pageListAll/pageEightyFour/loginSecond.vue'),
    meta: {
      title: '星贷',
    },
  },
  {
    path: '/IFPageEightyFourOnline',
    name: 'pageEightyFourOnline',
    component: () => import('@/pages/pageListAll/pageEightyFour/online.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageEightyFourLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageEightyFourGuide',
    name: 'pageEightyFourLoginGuide',
    component: () => import('@/pages/pageListAll/pageEightyFour/guide.vue'),
    meta: {
      title: '星贷',
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageEightyFourCar',
    name: 'pageEightyFourCar',
    component: () => import('@/pages/pageListAll/pageEightyFour/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageEightyFourBlank',
    name: 'pageEightyFourBlank',
    component: () => import('@/pages/pageListAll/pageEightyFour/blank.vue'),
    meta: {
      title: '星贷',
    },
  },
];
